import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CreateParticipantRestrictivePracticeLabel } from '../mutations/createParticipantRestrictivePracticeLabel.mutation';
import type {
  CreateParticipantRestrictivePracticeLabelMutation,
  CreateParticipantRestrictivePracticeLabelMutationVariables,
} from '../types';

export const useCreateParticipantRestrictivePracticeLabelMutation = (
  options?: MutationOptions<
    CreateParticipantRestrictivePracticeLabelMutation,
    CreateParticipantRestrictivePracticeLabelMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantRestrictivePracticeLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
